import { render, staticRenderFns } from "./OwnClassTeacherFilter.vue?vue&type=template&id=0a34c989&scoped=true"
import script from "./OwnClassTeacherFilter.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherFilter.vue?vue&type=script&lang=js"
import style0 from "./OwnClassTeacherFilter.vue?vue&type=style&index=0&id=0a34c989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34c989",
  null
  
)

export default component.exports